<template>
  <div class="contact-options">
    <h2 class="pb-5">
      {{ $t('global-need-help') }}
    </h2>
    <i18n
      path="complete-help-center-message"
      tag="h4"
      class="ref-id-note"
    >
      <a
        :href="helpLink"
        target="_blank"
        rel="noopener"
      >{{
        $t('help-center')
      }}</a>
    </i18n>
  </div>
</template>
<script>
export default {
  name: 'NeedHelp',
  computed: {
    helpLink () {
      return process.env.VUE_APP_KNOWLEDGE_BASE_URL
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/variables';

.contact-options {
  text-align: center;
  font-family: Gotham-Book;
  color: $tangoTextPrimary;

  h1 {
    font-size: 24px;
  }

  img {
    width: 32px;
    height: 64px;
  }

  span {
    display: block;
    font-weight: bolder;
  }

  .contact-option-item {
    float: left;
    min-height: 80px;
  }

  .ref-id-note {
    max-width: 460px;
    margin: 0 auto;
  }
}
</style>
